<div class="wrap-carousel wrap-carousel-product">
    <p-carousel
        [value]="listProduct"
        [numVisible]="4"
        [numScroll]="4"
        [circular]="false"
        [responsiveOptions]="responsiveOptions"
    >
        <ng-template let-item pTemplate="item">
            <li class="item">
                <a
                    *ngIf="userService.hasExtranetAccess('fonctions', 'comparateur-produit')"
                    (click)="addProductToCompare(item?.id)"
                    class="btn-common btn-comparer"
                >
                    <img
                        class="img-hover"
                        src="src-adisco/assets/images/icon/comparator-white.svg"
                        alt=""
                    />
                    <img
                        class="img-default"
                        src="src-adisco/assets/images/icon/comparator-blue.svg"
                        alt=""
                    />
                </a>
                <a
                    [routerLink]="['/catalogues/product-detail', item?.uniqueId]"
                    class="item-inner"
                    href="#"
                >
                    <div class="wrap-img">
                        <img
                            [src]="item?.mediumPhoto ? item?.mediumPhoto?.[0]?.url:'src-adisco/assets/images/image-default.jpeg'"
                            alt=""
                        />
                    </div>
                    <div class="wrap-info">
                        <p class="name font-bold">{{ item?.longDescription }}</p>
                        <p>
                            Référence fournisseur :
                            {{ item?.supplierItemNumber ? item?.supplierItemNumber : '-' }}
                        </p>
                        <p>Référence Adisco : {{ item?.uniqueId ? item?.uniqueId : '-' }}</p>
                        <p class="status">
                            Statut :
                            <span class="font-bold">{{ item?.productOpenOrClosed?.value }}</span>
                        </p>
                        <p>Fournisseur : {{ item?.companyName ? item?.companyName : '-' }}</p>
                        <p>Marque : {{ item?.brand ? item?.brand : '-' }}</p>
                        <p>
                            Dernière mise à jour :
                            {{
                                item?.updatingDate
                                    ? (item?.updatingDate | date : 'dd/MM/yyyy')
                                    : '-'
                            }}
                        </p>
                        <p
                            *ngIf="userService.hasExtranetAccess('fonctions', 'catalogue-tarifs')"
                            class="price font-bold"
                        >
                            <!-- {{ item?.pricelevelMaximum | renamePriceLevel }} : -->
                            {{ item?.pricelevelMaximum?.value | renamePriceLevel }} :
                            {{ item?.maximumPrice ? item?.maximumPrice : '-' }} € HT
                        </p>
                    </div>
                </a>
            </li>
        </ng-template>
    </p-carousel>
</div>
